(() => {
  if (window.spiritCommunityPageLoaded) return;
  window.spiritCommunityPageLoaded = true;

  const hydrateExternalVideo = (dialog) => {
    const template = dialog.querySelector('[data-spirit-community-external-video]');
    const target = dialog.querySelector('[data-spirit-community-external-video-target]');
    if (!template || !target || target.childElementCount > 0) return;

    const content = template.content.cloneNode(true);
    const frame = content.querySelector('iframe[data-src]');
    if (frame) frame.src = frame.dataset.src;
    target.replaceChildren(content);
  };

  const stopDialogMedia = (dialog) => {
    dialog.querySelectorAll('video').forEach((video) => video.pause());
    dialog.querySelector('[data-spirit-community-external-video-target]')?.replaceChildren();
  };

  const openDialog = (dialog, opener) => {
    if (!dialog) return;

    dialog.spiritCommunityOpener = opener;
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    document.body.classList.add('spirit-community-dialog-open');
    dialog.querySelector('[data-spirit-community-dialog-close]')?.focus();
    hydrateExternalVideo(dialog);
    dialog.querySelectorAll('video').forEach((video) => {
      const playback = video.play();
      playback?.catch(() => {});
    });
  };

  const closeDialog = (dialog) => {
    if (!dialog) return;

    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      stopDialogMedia(dialog);
      document.body.classList.remove('spirit-community-dialog-open');
      dialog.spiritCommunityOpener?.focus();
    }
  };

  const scrollRail = (root, control, step) => {
    const targetId = control.dataset.spiritCommunityRailTarget;
    const rail = targetId ? root.querySelector(`#${CSS.escape(targetId)}`) : null;
    const firstItem = rail?.firstElementChild;
    if (!rail || !firstItem) return;

    const railStyles = getComputedStyle(rail);
    const gap = Number.parseFloat(railStyles.columnGap || railStyles.gap) || 0;
    const distance = firstItem.getBoundingClientRect().width + gap;
    const direction = railStyles.direction === 'rtl' ? -1 : 1;

    rail.scrollBy({
      left: step * distance * direction,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  };

  const initializeCommunity = (root = document) => {
    root.querySelectorAll('[data-spirit-community]').forEach((community) => {
      if (community.dataset.spiritCommunityReady === 'true') return;
      community.dataset.spiritCommunityReady = 'true';

      community.querySelectorAll('[data-spirit-community-rail]').forEach((rail) => {
        rail.scrollLeft = 0;
      });

      community.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-spirit-community-dialog-open]');
        if (opener && community.contains(opener)) {
          const dialogId = opener.dataset.spiritCommunityDialogOpen;
          openDialog(community.querySelector(`#${CSS.escape(dialogId)}`), opener);
          return;
        }

        const closeButton = event.target.closest('[data-spirit-community-dialog-close]');
        if (closeButton) {
          closeDialog(closeButton.closest('[data-spirit-community-dialog]'));
          return;
        }

        const previous = event.target.closest('[data-spirit-community-rail-previous]');
        if (previous) {
          scrollRail(community, previous, -1);
          return;
        }

        const next = event.target.closest('[data-spirit-community-rail-next]');
        if (next) scrollRail(community, next, 1);
      });

      community.querySelectorAll('[data-spirit-community-dialog]').forEach((dialog) => {
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) closeDialog(dialog);
        });

        dialog.addEventListener('close', () => {
          stopDialogMedia(dialog);
          document.body.classList.remove('spirit-community-dialog-open');
          dialog.spiritCommunityOpener?.focus();
        });
      });
    });
  };

  initializeCommunity();
  document.addEventListener('shopify:section:load', (event) => initializeCommunity(event.target));
})();
